import { type FunctionComponent } from 'react';
import * as React from 'react';
import classNames from 'classnames';
import styles from './Field.scss';

type FieldProps = {
    children: React.ReactNode;
    className?: string;
};

export const Field: FunctionComponent<FieldProps> = ({ children, className }) => {
    return <div className={classNames(styles.fieldContainer, className)}>{children}</div>;
};
